module.exports = __webpack_public_path__ + "static/1305332035.896b0a6d.jpg";